import { Paper, TablePagination } from "@mui/material";
import TableHead from "../../../../../../components/@common/TableHead";
import TableBody from "../../../../../../components/@common/TableBody";
import {
  Box,
  Container,
  TableContainer,
  Table,
  TableRow,
  Link,
} from "@mui/material";
import MuiTableCell from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import {
  ConditionalRenderer,
  useLanguageTranslator,
  StatusTag,
} from "../../../../../../components";
import dayjs from "dayjs";

const TableCell = styled(MuiTableCell)({
  textWrap: "nowrap",
});

function SubmissionTable({
  viewAllPath = "",
  isAllShow = false,
  data = [],
  viewPath = "",
  metadata = {},
  setPage = () => {},
  page = null,
  setRowsPerPage = () => {},
  rowsPerPage = null,
  isAdminPeople,
}: any) {
  const { translator } = useLanguageTranslator();

  const handleChangePage = (event: any, newPage: any) => {
    setPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(+event.target.value);
    setPage(1);
  };

  return (
    <Paper>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{translator("dashboardTableHead.Name")}</TableCell>
              <TableCell>
                {translator("dashboardTableHead.Description")}
              </TableCell>
              <TableCell>{translator("dashboardTableHead.Status")}</TableCell>
              <TableCell>
                {translator("dashboardTableHead.Uploaded date")}
              </TableCell>
              <TableCell>{translator("dashboardTableHead.Action")}</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {data?.map((elem: any, i: number) => (
              <TableRow key={`${i}`}>
                <TableCell>
                  {isAdminPeople
                    ? `${elem?.firstname} ${elem?.lastname}`
                    : `${elem?.title} ${i + 1}`}
                </TableCell>
                <TableCell title={elem?.description}>
                  {elem?.description?.slice(0, 30) || "-"}
                </TableCell>
                <TableCell padding="checkbox">
                  <StatusTag
                    sx={{ padding: "0px" }}
                    label={elem?.statusLabel}
                    status={elem?.status}
                  />
                </TableCell>
                <TableCell>
                  {dayjs(elem?.createdAt?.split("T")?.[0] || "").format(
                    "DD.MM.YYYY"
                  )}
                </TableCell>
                <TableCell padding="checkbox">
                  <Link
                    href={`${viewPath}${elem?.id}`}
                    sx={{
                      backgroundColor: "#00AAB0",
                      color: "white",
                      padding: "6px 30px",
                      borderRadius: "25px",
                    }}
                  >
                    {translator("dashboardTableHead.View")}
                  </Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <ConditionalRenderer condition={isAllShow}>
        <TablePagination
          // rowsPerPageOptions={[10, 25, 100]}
          rowsPerPageOptions={[]}
          component="div"
          count={
            metadata?.totalPages
              ? metadata?.totalPages * rowsPerPage
              : data?.length
          }
          rowsPerPage={10}
          // page={page}
          page={page - 1}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </ConditionalRenderer>

      <ConditionalRenderer condition={!isAllShow}>
        <Box component={Container} sx={{ py: 3 }} textAlign="right">
          <Link href={viewAllPath} underline="none" color="textSecondary">
            {translator("View all")}
          </Link>
        </Box>
      </ConditionalRenderer>
    </Paper>
  );
}

export { SubmissionTable };
